import { render } from "./EditSentNote2.vue?vue&type=template&id=10965990&ts=true"
import script from "./EditSentNote2.vue?vue&type=script&lang=ts"
export * from "./EditSentNote2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__